module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// ./~/velocity-react/~/lodash/extend.js
// module id = 3799
// module chunks = 4